import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PediatricNeurologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.2144 40C80.2144 61.8153 62.5296 79.5 40.7144 79.5C18.8991 79.5 1.21436 61.8153 1.21436 40C1.21436 18.1848 18.8991 0.5 40.7144 0.5C62.5296 0.5 80.2144 18.1848 80.2144 40Z'
    />
    <g clipPath='url(#clip0_414_8969)'>
      <path
        d='M22.7658 30.2882C20.3596 29.64 17.9912 31.4533 17.9912 33.9453C17.9912 36.5788 20.6139 38.4109 23.0533 37.5125C23.1737 37.4681 25.1924 36.6642 25.5655 34.7027C25.9008 32.9401 24.7621 31.0036 22.7658 30.2882Z'
        fill='#FFBBAE'
      />
      <path
        d='M58.6623 30.2882C61.0685 29.64 63.4369 31.4533 63.4369 33.9453C63.4369 36.5788 60.8227 38.3875 58.3748 37.5125C56.519 37.2947 55.1218 35.7326 55.1051 33.9453C55.0873 32.0311 56.6575 30.3677 58.6623 30.2882Z'
        fill='#FFCCBF'
      />
      <path
        d='M55.8679 61.9559C55.8831 63.6329 54.526 65 52.8491 65H50.5575L49.803 63.994L49.0485 65H42.1567C36.979 64.8211 33.3172 60.7412 33.4421 57.0315C33.5813 52.8956 38.4446 48.7174 44.217 49.9291H47.8113C52.6318 52.2539 55.8186 56.8607 55.8679 61.9559Z'
        fill='#FFCCBF'
      />
      <path
        d='M42.1566 65H32.3796L31.6251 63.994L30.8706 65H28.5781C26.9011 65 25.5441 63.6329 25.5592 61.956C25.6055 56.8477 28.8044 52.251 33.618 49.9292H44.2168C39.2874 53.2723 38.3748 60.3985 42.1566 65Z'
        fill='#FFBBAE'
      />
      <path
        d='M32.3796 58.941V64.9999H30.8706V58.941C30.8706 58.5235 31.2076 58.1865 31.6251 58.1865C32.0416 58.1865 32.3796 58.5235 32.3796 58.941Z'
        fill='#F29C8C'
      />
      <path
        d='M50.5573 58.941V64.9999H49.0483V58.941C49.0483 58.5235 49.3863 58.1865 49.8028 58.1865C50.2203 58.1865 50.5573 58.5235 50.5573 58.941Z'
        fill='#FFBBAE'
      />
      <path
        d='M58.8929 33.1884C58.8929 42.6153 51.7164 50.3663 42.529 51.2766C41.1568 51.4134 39.8079 51.3943 38.4981 51.2343C12.4377 36.2133 37.3804 15.3054 37.3804 15.3054C39.7444 14.8638 42.2493 14.887 44.7813 15.4673C52.8633 17.3133 58.8929 24.5462 58.8929 33.1884Z'
        fill='#FFDED0'
      />
      <path
        d='M38.4982 51.2343C29.5944 50.1509 22.5356 42.568 22.5356 33.1884C22.5356 24.1207 29.0995 16.8556 37.3807 15.3054C34.4572 19.8775 24.1109 38.348 38.4982 51.2343Z'
        fill='#FFCCBF'
      />
      <path
        d='M54.004 29.1474C53.8282 28.7966 53.7344 28.4103 53.7159 28.0192C53.6123 25.8241 52.1968 24.3558 50.2727 24.1108C49.5324 24.0166 48.8636 23.6331 48.3784 23.0717C46.9023 21.3638 44.7142 20.6394 42.7186 21.3264C41.5094 21.7427 40.7141 22.8909 40.7141 24.1582C38.1241 25.7481 38.1707 29.34 40.7141 30.9329C40.7235 32.6191 42.0914 33.9454 43.758 33.9454H50.9331C53.4436 33.9454 55.0992 31.3311 54.004 29.1474Z'
        fill='#FFA1AC'
      />
      <path
        d='M46.9106 25.6377C46.494 25.6471 46.1639 25.9923 46.1732 26.4089C46.1863 26.9968 45.6383 27.6462 44.8769 27.5032C43.4893 25.832 40.499 26.012 39.425 28.3507C39.2511 28.7293 39.4172 29.1773 39.7958 29.3512C40.1745 29.5252 40.6223 29.359 40.7963 28.9804C41.5228 27.3981 43.6088 27.7515 43.9299 28.8732C44.076 29.3835 43.8711 29.9687 43.408 30.3639C42.8763 30.8177 43.199 31.6923 43.8981 31.6923C44.0714 31.6923 44.2455 31.6329 44.3876 31.5117C45.1464 30.8642 45.542 29.9252 45.476 29.0073C47.6745 28.6768 48.3907 25.6056 46.9106 25.6377Z'
        fill='#FF6E80'
      />
      <path
        d='M50.1235 27.9262C49.7151 28.0091 49.4513 28.4072 49.5342 28.8156C49.6721 29.4953 49.2491 30.1616 48.4223 30.1837C48.0058 30.1948 47.6771 30.5415 47.6883 30.958C47.6992 31.3677 48.0347 31.6924 48.4421 31.6924C51.3908 31.6924 51.749 27.596 50.1235 27.9262Z'
        fill='#FF6E80'
      />
      <path
        d='M40.7141 26.883L40.2695 27.5067L40.7141 29.1182V30.933C40.7141 32.5968 39.351 33.9448 37.6701 33.9448H31.0579C27.9585 30.0578 33.5677 22.5996 33.7055 22.4165C33.7076 22.4144 33.7086 22.4134 33.7086 22.4134C35.2628 21.0785 37.2405 20.7456 38.8088 21.3632C39.9617 21.8058 40.7141 22.9265 40.7141 24.1578V26.883Z'
        fill='#FF6E80'
      />
      <path
        d='M33.7086 22.4136C32.3647 25.7021 31.1978 29.7179 31.058 33.9449H30.4957C27.9848 33.9449 26.329 31.3314 27.4245 29.1475C27.6005 28.7964 27.6941 28.4101 27.7122 28.0187C27.8178 25.7926 29.2584 24.354 31.1555 24.1105C31.896 24.016 32.5649 23.6327 33.0498 23.0714C33.2581 22.8301 33.4794 22.6107 33.7086 22.4136Z'
        fill='#F9475E'
      />
      <path
        d='M36.5513 27.5037C35.774 27.6485 35.2429 26.969 35.2546 26.4092C35.2646 25.9927 34.9337 25.6467 34.5172 25.6376C33.0613 25.5985 33.7394 28.6788 35.9527 29.0076C35.8863 29.9251 36.2816 30.8646 37.0401 31.5114C37.183 31.6331 37.357 31.6925 37.5301 31.6925C38.2292 31.6925 38.5521 30.8173 38.02 30.3636C37.5573 29.9682 37.352 29.3838 37.4979 28.8727C37.7031 28.1575 38.5351 27.904 39.0411 27.905C40.215 27.912 40.6154 28.9894 40.7141 29.1181V26.8829C39.2725 25.9857 37.4517 26.4183 36.5513 27.5037Z'
        fill='#F9475E'
      />
      <path
        d='M33.7396 30.9581C33.7286 31.3755 33.3806 31.7035 32.966 31.6924C32.3041 31.6744 31.7377 31.45 31.3042 31.0918C30.3867 29.0044 31.8173 28.3074 31.8173 28.3074C31.8998 28.4573 31.9309 28.6353 31.8937 28.8154C31.7549 29.5014 32.1865 30.1614 33.0063 30.1834C33.4227 30.1946 33.7507 30.5417 33.7396 30.9581Z'
        fill='#F9475E'
      />
      <path
        d='M31.8173 28.3075C31.6091 29.2138 31.434 30.1444 31.3042 31.0919C30.5698 30.4894 30.2138 29.5095 30.4149 28.5157C30.5564 27.8244 31.4876 27.6904 31.8173 28.3075Z'
        fill='#EA2849'
      />
      <path
        d='M40.714 35.4631C40.2973 35.4631 39.9595 35.8009 39.9595 36.2176V47.5791C39.9595 47.9958 40.2973 48.3335 40.714 48.3335C41.1307 48.3335 41.4685 47.9958 41.4685 47.5791V36.2176C41.4685 35.8009 41.1307 35.4631 40.714 35.4631Z'
        fill='#FF6E80'
      />
      <path
        d='M38.4386 40.0048C38.4386 38.6447 37.8139 37.2644 36.6218 36.3713C36.2888 36.1218 35.8159 36.1891 35.5655 36.5231C35.316 36.856 35.3835 37.3289 35.7174 37.5784C37.0951 38.6112 36.9296 40.0596 36.9296 41.0369C36.1635 40.6063 35.2564 40.5327 34.4228 40.8015C34.0264 40.9304 33.8081 41.3549 33.9369 41.7512C34.0647 42.1485 34.4902 42.3658 34.8865 42.2381C35.323 42.0969 35.762 42.1319 36.1364 42.3237C36.7145 42.7648 36.7755 42.846 36.9297 43.1837C36.9297 43.3272 36.9236 43.3688 36.9387 43.5022C36.9357 43.4953 36.9326 43.4884 36.9297 43.4814V46.0647C36.9297 46.8902 38.0743 47.1129 38.3833 46.3474C38.4691 46.1397 38.4386 46.3378 38.4386 40.0048Z'
        fill='#FF6E80'
      />
      <path
        d='M47.0055 40.8018C46.2003 40.5418 45.2905 40.5925 44.4982 41.0373V40.0143C44.5246 39.0099 44.9551 38.1453 45.7109 37.579C46.0444 37.3292 46.1122 36.8562 45.8624 36.5228C45.6126 36.1894 45.1397 36.1216 44.8062 36.3714C43.6197 37.2602 42.9893 38.6376 42.9893 40.005V46.0644C42.9893 46.4811 43.327 46.8189 43.7437 46.8189C44.1604 46.8189 44.4982 46.4811 44.4982 46.0644V43.1839C44.8879 42.3317 45.7188 41.9719 46.5416 42.2378C46.938 42.3659 47.3633 42.1482 47.4915 41.7517C47.6195 41.3553 47.402 40.93 47.0055 40.8018Z'
        fill='#FF6E80'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_8969'>
        <rect width='50' height='50' fill='white' transform='translate(15.7144 15)' />
      </clipPath>
    </defs>
  </svg>
));
PediatricNeurologyIcon.displayName = 'PediatricNeurologyIcon';

export default PediatricNeurologyIcon;
